
export default function SkillsDatabase() {
    return [
        {
            "title": "Backend Engineering",
            "text": "In my carrer I worked on complex backend systems, focused on performance and reliability. I am using/used: Hack/PHP, Python, .Net, Node.js and their tools.",
        },
        {
            "title": "Frontend Engineering",
            "text": "I am a Fullstack Developer  and I know my way around Javscript/Typescript, HTML5, CSS3. The main framework I work with is React and based on the needs Redux.",
        },
        {
            "title": "Data",
            "text": "I worked with a lot of different data management systems in my carrer like RDBMS, NoSQL, GDB. And to be more specific PostgresSQL, MySQL, Redis and more.",
        },
        {
            "title": "Reliability",
            "text": "I always think of the most reliable way to make system/service work well now and in the future. Make it scalable, extendable and create logging infrastructure that provides the most value."
        },
    ]
}